import request from './request.js';
import {requestbody} from './request.js'

export async function groupList(params = {

}) {
    return await requestbody('/system/dept/getDeptTreeTableList', 'get', params)
}

export async function DeptChildrenUser(params = {

}) {
    return await requestbody('/sys/getDeptChildrenUser', 'post', params)
}

export async function save(params = {

}) {
    return await requestbody('/system/user/save', 'post', params)
}

export async function roleall(params = {

}) {
    return await request('/sys/selectRoles', 'post', params)
}
export async function optiondelete(params = {

}) {
    return await requestbody('/system/user/deleteBatch', 'post', params)
}

export async function flieUser(params = {

}) {
    return await request('/sys/importUser', 'post', params)
}

export async function userupdate(params = {

}) {
    return await requestbody('/system/user/update', 'post', params)
}
